/* eslint-disable camelcase */
import styled from '@emotion/styled';
import { useMemo } from 'react';
import { Image } from 'antd';
import { css } from '@emotion/css';
import { VideoPreviewer } from 'components/Dialogue/components/Message/VideoMessage/VideoPreview';

export interface ImageSlideProps {
  reviewDetail:
    | Pick<Review.ReviewDetail, 'imageUrls' | 'videoUrls'>
    | {
        imageUrls: string[];
        videoUrls: string[];
      };
}

function ImageSlide(props: ImageSlideProps) {
  const { reviewDetail } = props;

  const { images, videos } = useMemo(() => {
    const { imageUrls, videoUrls } = reviewDetail;

    if (Array.isArray(imageUrls) || Array.isArray(videoUrls)) {
      return {
        images: imageUrls as string[],
        videos: videoUrls as string[],
      };
    }

    let images: string[] = [];
    let videos: string[] = [];

    try {
      images = JSON.parse(imageUrls);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    }

    try {
      videos = (JSON.parse(videoUrls) as ({ video_url: string } | string)[]).map((item) => {
        return (item as { video_url: string }).video_url || (item as string);
      });
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    }

    return {
      images,
      videos,
    };
  }, [reviewDetail]);

  if (images.length + videos.length === 0) {
    return null;
  }

  return (
    <Container>
      {videos.map((url) => (
        <VideoPreviewer url={url} className={videoWrappCls} />
      ))}
      <Image.PreviewGroup>
        {images.map((img) => (
          <Image width={60} height={60} src={img} />
        ))}
      </Image.PreviewGroup>
    </Container>
  );
}

export default ImageSlide;

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const videoWrappCls = css`
  min-width: 60px !important;
  max-width: 60px !important;
  max-height: 60px !important;
  overflow: hidden;

  .anticon-play-circle {
    font-size: 28px;
  }

  img {
    width: 60px;
    min-width: 60px;
    max-width: 60px;
    min-height: 60px;
    height: 60px;
    object-fit: cover;
  }
`;
